import { Injectable } from '@angular/core';
import { HTTP,HTTPResponse } from '@ionic-native/http';
import { ConfigurationManager } from './ConfigurationManager';

@Injectable()
export class ToggleFavouriteService {


    constructor(private http: HTTP, private config: ConfigurationManager) { }

    setFavourite(data) {


        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': this.config.environmentConfig.apikey,
            'Accept': 'application/json'
        };

        let flag: boolean;
        if (data.FavoritePartnerFlag === 'true') {
            flag = true;
        } else if (data.FavoritePartnerFlag === 'false') {
            flag = false;
        } else {
            flag = data.FavoritePartnerFlag;
        }
        let dealid = '0';
        if (data.DealID != null) {
            dealid = data.DealID;
        }
        const body = {
            'DealID': dealid + '',
            'PartnerID': data.PartnerID + '',
            'FavoritePartnerFlag': !flag,
            'SessionID': this.config.getSessionId,
            'ProxyUI': this.config.getProxyUI + '',
            'ClubID': this.config.getClubCode + '',
            'FromNewDNR': 'true',
        };

        console.log('params' + body);
        const url = this.config.environmentConfig.baseurl + 'tofap/v1';
        this.http.setDataSerializer('json');
        return this.http.post(url, body, headers);

    }

}
